import React from 'react';
import { Link } from 'react-router-dom';
import { FaHeart, FaGavel, FaShoppingCart, FaUser, FaEnvelope } from 'react-icons/fa';

const SponsoredCard = ({ horse }) => {
  if (!horse || typeof horse !== 'object') {
    return <div className="p-3 bg-red-100 text-red-700">Invalid horse object</div>;
  }

  const info = horse.horseInfo || {};
  const sale = horse.saleInfo || {};
  const location = info.location || {};
  const details = location.details || {};

  const safeName = typeof info.name === 'string' ? info.name : 'No Name';
  const safeBreed = typeof info.breed?.name === 'string' ? info.breed.name : 'Unknown';
  const safePrice = typeof sale.buyNowPrice === 'number'
    ? `$${sale.buyNowPrice.toLocaleString()}`
    : typeof sale.auctionStartingPrice === 'number'
    ? `$${sale.auctionStartingPrice.toLocaleString()}`
    : 'N/A';
  const safeStatus = sale.saleType || 'N/A';
  const safeLocationCity = details.city || 'Unknown';
  const safeLocationState = details.state || 'Unknown';
  const safeImage = Array.isArray(info.images) && typeof info.images[0] === 'string'
    ? info.images[0]
    : '/placeholder.jpg';

  return (
    <div className="relative bg-white border rounded shadow border-2 border-sage overflow-hidden group">
      <div className="bg-gray-100 overflow-hidden">
        <img
          src={safeImage}
          alt={safeBreed}
          className="w-full h-full object-cover"
        />
      </div>

      <div className="p-3 text-sm text-text font-montserrat">
        <h3 className="font-semibold text-2xl truncate">{safeName}</h3>
        <p className='py-1 font-medium'><strong>Breed:</strong> {safeBreed}</p>
        <p className='py-1 font-medium'><strong>Price:</strong> {safePrice}</p>
        <p className='py-1 font-medium'><strong>Status:</strong> {safeStatus}</p>
        <p className='py-1 font-medium'><strong>Location:</strong> {safeLocationCity}, {safeLocationState}</p>

        <div className="flex flex-wrap gap-2 mt-4">
          <button className="flex items-center gap-1 bg-primary text-white px-3 py-1 rounded shadow text-xs">
            <FaHeart size={14} /> Favorite
          </button>

          {sale?.saleType === 'Buy Now' && (
            <button className="flex items-center gap-1 bg-primary text-white px-3 py-1 rounded shadow text-xs">
              <FaShoppingCart size={14} /> Buy Now
            </button>
          )}

          {sale?.saleType === 'Auction' && (
            <button className="flex items-center gap-1 bg-sage text-white px-3 py-1 rounded shadow text-xs">
              <FaGavel size={14} /> Bid
            </button>
          )}

          {sale?.saleType === 'Hybrid' && (
            <div className="flex flex-col gap-2 sm:flex-row">
              <button className="flex items-center gap-1 bg-primary text-white px-3 py-1 rounded shadow text-xs">
                <FaShoppingCart size={14} /> Buy Now
              </button>
              <button className="flex items-center gap-1 bg-sage text-white px-3 py-1 rounded shadow text-xs">
                <FaGavel size={14} /> Bid
              </button>
            </div>
          )}

          <button className="flex items-center gap-1 bg-blue-600 text-white px-3 py-1 rounded shadow text-xs">
            <FaEnvelope size={14} /> Inquire
          </button>
          <Link to={`/profile/${horse.owner || ''}`} state={{ fromSearch: true }} className="flex items-center gap-1 bg-gray-800 text-white px-3 py-1 rounded shadow text-xs">
            <FaUser size={14} /> Seller Profile
          </Link>
          <Link to={`/horses/${horse._id || ''}`} state={{ fromSearch: true }} className="flex items-center gap-1 bg-gray-800 text-white px-3 py-1 rounded shadow text-xs">
            <FaUser size={14} /> Horse Profile
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SponsoredCard;